import { useState, useEffect } from 'react';
import axios from '../../api/Axios';

const countries = [
  "South Africa", "United Kingdom", "United States", "India", "China", "Nigeria", "Germany", "France", "Brazil", "Canada", "Australia", "Zimbabwe", "Kenya", "Botswana", "Namibia", "Lesotho", "Swaziland", "Mozambique", "Ghana", "Uganda", "Tanzania", "Egypt", "Morocco", "Japan", "South Korea", "Russia", "Italy", "Spain", "Portugal", "Netherlands", "Belgium", "Sweden", "Norway", "Denmark", "Finland", "Poland", "Turkey", "Argentina", "Chile", "Mexico", "Colombia", "Peru", "Indonesia", "Malaysia", "Singapore", "Thailand", "Vietnam", "Philippines", "Pakistan", "Bangladesh", "Sri Lanka", "Nepal", "Ethiopia", "Sudan", "Angola", "Cameroon", "Ivory Coast", "Senegal", "Tunisia", "Algeria", "Libya", "Iraq", "Iran", "Israel", "Saudi Arabia", "UAE", "Qatar", "Kuwait", "Jordan", "Lebanon", "Syria", "Afghanistan", "New Zealand", "Other"
];

const ManageInstitution = () => {
  const [country, setCountry] = useState('');
  const [name, setName] = useState('');
  const [type, setType] = useState('');
  const [address, setAddress] = useState('');
  const [abbrev, setAbbrev] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setResult(null);
    setError('');

    try {
      const payload = {
        name,
        institution_type: type,
        address,
        abbrev,
        country,
      };
      const response = await axios.post('api/institution_create/', payload);
      setResult(response.data);
    } catch (err) {
      setError(
        err.response?.data
          ? JSON.stringify(err.response.data)
          : "Submission failed"
      );
    }
  };

  return (
    <div className="booking-form mt-4">
      <h4 className="mb-3">Add Institution</h4>
      <form onSubmit={handleSubmit}>
        <div className="form-row mb-3">
          <div className="form-group col-md-6 mb-3">
            <select
              className="form-control homeforms"
              value={country}
              onChange={e => setCountry(e.target.value)}
              required
            >
              <option value="">Select Country</option>
              {countries.map((c) => (
                <option key={c} value={c}>{c}</option>
              ))}
            </select>
          </div>
          <div className="form-group col-md-6 mb-3">
            <input
              className="form-control homeforms"
              type="text"
              placeholder="Enter institution name"
              value={name}
              onChange={e => setName(e.target.value)}
              required
            />
          </div>
        </div>
        <div className="form-row mb-3">
          <div className="form-group col-md-6 mb-3">
            <select
              className="form-control homeforms"
              value={type}
              onChange={e => setType(e.target.value)}
              required
            >
              <option value="">Select Type</option>
              <option value="University">University</option>
              <option value="Technikon">Technikon</option>
              <option value="Institute of Higher Learning">Institute of Higher Learning</option>
            </select>
          </div>
          <div className="form-group col-md-6 mb-3">
            <input
              className="form-control homeforms"
              type="text"
              placeholder="Enter address"
              value={address}
              onChange={e => setAddress(e.target.value)}
              required
            />
          </div>
        </div>
        <div className="form-row mb-3">
          <div className="form-group col-md-6 mb-3">
            <input
              className="form-control homeforms"
              type="text"
              placeholder="Enter abbreviation"
              value={abbrev}
              onChange={e => setAbbrev(e.target.value)}
              required
            />
          </div>
        </div>
        <div className="form-btn">
          <button className="btn btn-primary btn-block" type="submit">
            Submit
          </button>
        </div>
      </form>
      {result && (
        <div className="alert alert-success mt-3">
          Success: {JSON.stringify(result)}
        </div>
      )}
      {error && (
        <div className="alert alert-danger mt-3">
          Error: {error}
        </div>
      )}
    </div>
  );
};

const Progressions = () => {
  const [type, setType] = useState('');
  const [period, setPeriod] = useState('');
  const [year, setYear] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
    alert(`Type: ${type}, Period: ${period}, Year: ${year}`);
  };

  return (
    <div className="booking-form mt-4">
      <h4 className="mb-3">Progressions</h4>
      <form onSubmit={handleSubmit}>
        <div className="form-row mb-3">
          <div className="form-group col-md-4 mb-3">
            <select
              className="form-control homeforms"
              value={type}
              onChange={e => setType(e.target.value)}
              required
            >
              <option value="">Select Type</option>
              <option value="one">One</option>
              <option value="two">Two</option>
            </select>
          </div>
          <div className="form-group col-md-4 mb-3">
            <select
              className="form-control homeforms"
              value={period}
              onChange={e => setPeriod(e.target.value)}
              required
            >
              <option value="">Select Period</option>
              <option value="2">Semester (2)</option>
              <option value="3">Trimester (3)</option>
              <option value="1">Annual (1)</option>
            </select>
          </div>
          <div className="form-group col-md-4 mb-3">
            <select
              className="form-control homeforms"
              value={year}
              onChange={e => setYear(e.target.value)}
              required
            >
              <option value="">Select Year</option>
              <option value="2025">2025</option>
              <option value="2026">2026</option>
            </select>
          </div>
        </div>
        <div className="form-btn">
          <button className="btn btn-primary btn-block" type="submit">
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

const ManageTerms = () => {
  const [institutions, setInstitutions] = useState([]);
  const [selectedInstitution, setSelectedInstitution] = useState('');
  const [academicYear, setAcademicYear] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [existingTerms, setExistingTerms] = useState(null);

  // Semester dates
  const [semesterOneStart, setSemesterOneStart] = useState('');
  const [semesterOneEnd, setSemesterOneEnd] = useState('');
  const [semesterTwoStart, setSemesterTwoStart] = useState('');
  const [semesterTwoEnd, setSemesterTwoEnd] = useState('');

  // Trimester dates
  const [trimesterOneStart, setTrimesterOneStart] = useState('');
  const [trimesterOneEnd, setTrimesterOneEnd] = useState('');
  const [trimesterTwoStart, setTrimesterTwoStart] = useState('');
  const [trimesterTwoEnd, setTrimesterTwoEnd] = useState('');
  const [trimesterThreeStart, setTrimesterThreeStart] = useState('');
  const [trimesterThreeEnd, setTrimesterThreeEnd] = useState('');

  // Annual dates
  const [annualStart, setAnnualStart] = useState('');
  const [annualEnd, setAnnualEnd] = useState('');

  // Fetch institutions on component mount
  useEffect(() => {
    const fetchInstitutions = async () => {
      try {
        const response = await axios.get('api/institutions/');
        // Sort institutions alphabetically by name
        const sortedInstitutions = response.data.sort((a, b) => 
          a.name.localeCompare(b.name)
        );
        setInstitutions(sortedInstitutions);
      } catch (err) {
        console.error('Failed to fetch institutions:', err);
      }
    };
    fetchInstitutions();
  }, []);

  // Fetch existing terms when institution and year are selected
  useEffect(() => {
    const fetchExistingTerms = async () => {
      if (selectedInstitution && academicYear) {
        try {
          const response = await axios.get(`api/terms/view/?institution=${selectedInstitution}&academic_year=${academicYear}`);
          if (response.data && response.data.length > 0) {
            setExistingTerms(response.data[0]);
          } else {
            setExistingTerms(null);
          }
        } catch (err) {
          console.error('Failed to fetch existing terms:', err);
          setExistingTerms(null);
        }
      } else {
        setExistingTerms(null);
      }
    };
    fetchExistingTerms();
  }, [selectedInstitution, academicYear]);

  const handleDeleteTerm = async (termType) => {
    if (!existingTerms) return;
    
    try {
      // Create updated payload with deleted term set to null
      const payload = {
        ...existingTerms,
        [`${termType}_start`]: null,
        [`${termType}_end`]: null,
      };
      
      await axios.put(`api/terms/${existingTerms.id}/`, payload);
      setResult(`${termType} deleted successfully!`);
      
      // Refresh the terms data
      const response = await axios.get(`api/terms/view/?institution=${selectedInstitution}&academic_year=${academicYear}`);
      if (response.data && response.data.length > 0) {
        setExistingTerms(response.data[0]);
      } else {
        setExistingTerms(null);
      }
    } catch (err) {
      setError(`Failed to delete ${termType}: ${err.response?.data || err.message}`);
    }
  };

  const validateDates = () => {
    // Semester One validation
    if ((semesterOneStart && !semesterOneEnd) || (!semesterOneStart && semesterOneEnd)) {
      return 'Semester One requires both start and end dates, or leave both empty';
    }

    // Semester Two validation
    if ((semesterTwoStart && !semesterTwoEnd) || (!semesterTwoStart && semesterTwoEnd)) {
      return 'Semester Two requires both start and end dates, or leave both empty';
    }

    // Trimester One validation
    if ((trimesterOneStart && !trimesterOneEnd) || (!trimesterOneStart && trimesterOneEnd)) {
      return 'Trimester One requires both start and end dates, or leave both empty';
    }

    // Trimester Two validation
    if ((trimesterTwoStart && !trimesterTwoEnd) || (!trimesterTwoStart && trimesterTwoEnd)) {
      return 'Trimester Two requires both start and end dates, or leave both empty';
    }

    // Trimester Three validation
    if ((trimesterThreeStart && !trimesterThreeEnd) || (!trimesterThreeStart && trimesterThreeEnd)) {
      return 'Trimester Three requires both start and end dates, or leave both empty';
    }

    // Annual validation
    if ((annualStart && !annualEnd) || (!annualStart && annualEnd)) {
      return 'Annual period requires both start and end dates, or leave both empty';
    }

    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setResult(null);
    setError('');

    // Validate required fields
    if (!selectedInstitution) {
      setError('Please select an institution');
      return;
    }

    if (!academicYear) {
      setError('Please enter an academic year');
      return;
    }

    // Validate dates
    const validationError = validateDates();
    if (validationError) {
      setError(validationError);
      return;
    }

    try {
      const payload = {
        institution: selectedInstitution,
        academic_year: parseInt(academicYear),
        semester_one_start: semesterOneStart || null,
        semester_one_end: semesterOneEnd || null,
        semester_two_start: semesterTwoStart || null,
        semester_two_end: semesterTwoEnd || null,
        trimester_one_start: trimesterOneStart || null,
        trimester_one_end: trimesterOneEnd || null,
        trimester_two_start: trimesterTwoStart || null,
        trimester_two_end: trimesterTwoEnd || null,
        trimester_three_start: trimesterThreeStart || null,
        trimester_three_end: trimesterThreeEnd || null,
        annual_start: annualStart || null,
        annual_end: annualEnd || null,
      };

      let response;
      if (existingTerms && existingTerms.id) {
        // Update existing record - merge with existing data
        const mergedPayload = {
          ...existingTerms,
          ...payload,
          // Only update fields that have values, preserve existing values for empty fields
          semester_one_start: semesterOneStart || existingTerms.semester_one_start,
          semester_one_end: semesterOneEnd || existingTerms.semester_one_end,
          semester_two_start: semesterTwoStart || existingTerms.semester_two_start,
          semester_two_end: semesterTwoEnd || existingTerms.semester_two_end,
          trimester_one_start: trimesterOneStart || existingTerms.trimester_one_start,
          trimester_one_end: trimesterOneEnd || existingTerms.trimester_one_end,
          trimester_two_start: trimesterTwoStart || existingTerms.trimester_two_start,
          trimester_two_end: trimesterTwoEnd || existingTerms.trimester_two_end,
          trimester_three_start: trimesterThreeStart || existingTerms.trimester_three_start,
          trimester_three_end: trimesterThreeEnd || existingTerms.trimester_three_end,
          annual_start: annualStart || existingTerms.annual_start,
          annual_end: annualEnd || existingTerms.annual_end,
        };
        response = await axios.put(`api/terms/${existingTerms.id}/`, mergedPayload);
        setResult('Terms updated successfully!');
      } else {
        // Create new record
        response = await axios.post('api/terms/', payload);
        setResult('Terms created successfully!');
      }
      
      // Refresh existing terms
      const termsResponse = await axios.get(`api/terms/view/?institution=${selectedInstitution}&academic_year=${academicYear}`);
      if (termsResponse.data && termsResponse.data.length > 0) {
        setExistingTerms(termsResponse.data[0]);
      }
      
      // Clear form dates only
      setSemesterOneStart('');
      setSemesterOneEnd('');
      setSemesterTwoStart('');
      setSemesterTwoEnd('');
      setTrimesterOneStart('');
      setTrimesterOneEnd('');
      setTrimesterTwoStart('');
      setTrimesterTwoEnd('');
      setTrimesterThreeStart('');
      setTrimesterThreeEnd('');
      setAnnualStart('');
      setAnnualEnd('');
    } catch (err) {
      setError(
        err.response?.data
          ? JSON.stringify(err.response.data)
          : "Submission failed"
      );
    }
  };

  return (
    <div className="booking-form mt-4">
      <h4 className="mb-3">Manage Academic Terms</h4>
      
      {/* Existing Terms Table */}
      {existingTerms && selectedInstitution && academicYear && (
        <div className="mb-4">
          <h5>Existing Terms for {academicYear}</h5>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Term Type</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {existingTerms.semester_one_start && (
                <tr>
                  <td>Semester One</td>
                  <td>{existingTerms.semester_one_start}</td>
                  <td>{existingTerms.semester_one_end}</td>
                  <td>
                    <button 
                      type="button"
                      className="btn btn-danger btn-sm"
                      onClick={() => handleDeleteTerm('semester_one')}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              )}
              {existingTerms.semester_two_start && (
                <tr>
                  <td>Semester Two</td>
                  <td>{existingTerms.semester_two_start}</td>
                  <td>{existingTerms.semester_two_end}</td>
                  <td>
                    <button 
                      type="button"
                      className="btn btn-danger btn-sm"
                      onClick={() => handleDeleteTerm('semester_two')}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              )}
              {existingTerms.trimester_one_start && (
                <tr>
                  <td>Trimester One</td>
                  <td>{existingTerms.trimester_one_start}</td>
                  <td>{existingTerms.trimester_one_end}</td>
                  <td>
                    <button 
                      type="button"
                      className="btn btn-danger btn-sm"
                      onClick={() => handleDeleteTerm('trimester_one')}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              )}
              {existingTerms.trimester_two_start && (
                <tr>
                  <td>Trimester Two</td>
                  <td>{existingTerms.trimester_two_start}</td>
                  <td>{existingTerms.trimester_two_end}</td>
                  <td>
                    <button 
                      type="button"
                      className="btn btn-danger btn-sm"
                      onClick={() => handleDeleteTerm('trimester_two')}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              )}
              {existingTerms.trimester_three_start && (
                <tr>
                  <td>Trimester Three</td>
                  <td>{existingTerms.trimester_three_start}</td>
                  <td>{existingTerms.trimester_three_end}</td>
                  <td>
                    <button 
                      type="button"
                      className="btn btn-danger btn-sm"
                      onClick={() => handleDeleteTerm('trimester_three')}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              )}
              {existingTerms.annual_start && (
                <tr>
                  <td>Annual</td>
                  <td>{existingTerms.annual_start}</td>
                  <td>{existingTerms.annual_end}</td>
                  <td>
                    <button 
                      type="button"
                      className="btn btn-danger btn-sm"
                      onClick={() => handleDeleteTerm('annual')}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
      
      {/* Message when institution and year selected but no terms exist */}
      {!existingTerms && selectedInstitution && academicYear && (
        <div className="alert alert-info mb-4">
          No terms found for {academicYear}. Add terms using the form below.
        </div>
      )}
      
      <form onSubmit={handleSubmit}>
        <div className="form-row mb-3">
          <div className="form-group col-md-6 mb-3">
            <label>Select Institution</label>
            <select
              className="form-control homeforms"
              value={selectedInstitution}
              onChange={e => setSelectedInstitution(e.target.value)}
              required
            >
              <option value="">Select Institution</option>
              {institutions.map((inst) => (
                <option key={inst.id} value={inst.id}>{inst.name}</option>
              ))}
            </select>
          </div>
          <div className="form-group col-md-6 mb-3">
            <label>Academic Year</label>
            <input
              className="form-control homeforms"
              type="number"
              placeholder="e.g., 2024, 2025, 2026"
              value={academicYear}
              onChange={e => setAcademicYear(e.target.value)}
              min="2020"
              max="2100"
              required
            />
          </div>
        </div>

        {/* Semester Section */}
        <div className="mb-4">
          <h5>Semester Dates</h5>
          <div className="form-row mb-3">
            <div className="form-group col-md-6 mb-3">
              <label>Semester One Start</label>
              <input
                className="form-control homeforms"
                type="date"
                value={semesterOneStart}
                onChange={e => setSemesterOneStart(e.target.value)}
                min={academicYear ? `${academicYear}-01-01` : ''}
                max={academicYear ? `${academicYear}-12-31` : ''}
                disabled={!academicYear}
              />
            </div>
            <div className="form-group col-md-6 mb-3">
              <label>Semester One End</label>
              <input
                className="form-control homeforms"
                type="date"
                value={semesterOneEnd}
                onChange={e => setSemesterOneEnd(e.target.value)}
                min={academicYear ? `${academicYear}-01-01` : ''}
                max={academicYear ? `${academicYear}-12-31` : ''}
                disabled={!academicYear}
              />
            </div>
          </div>
          <div className="form-row mb-3">
            <div className="form-group col-md-6 mb-3">
              <label>Semester Two Start</label>
              <input
                className="form-control homeforms"
                type="date"
                value={semesterTwoStart}
                onChange={e => setSemesterTwoStart(e.target.value)}
                min={academicYear ? `${academicYear}-01-01` : ''}
                max={academicYear ? `${academicYear}-12-31` : ''}
                disabled={!academicYear}
              />
            </div>
            <div className="form-group col-md-6 mb-3">
              <label>Semester Two End</label>
              <input
                className="form-control homeforms"
                type="date"
                value={semesterTwoEnd}
                onChange={e => setSemesterTwoEnd(e.target.value)}
                min={academicYear ? `${academicYear}-01-01` : ''}
                max={academicYear ? `${academicYear}-12-31` : ''}
                disabled={!academicYear}
              />
            </div>
          </div>
        </div>

        {/* Trimester Section */}
        <div className="mb-4">
          <h5>Trimester Dates</h5>
          <div className="form-row mb-3">
            <div className="form-group col-md-6 mb-3">
              <label>Trimester One Start</label>
              <input
                className="form-control homeforms"
                type="date"
                value={trimesterOneStart}
                onChange={e => setTrimesterOneStart(e.target.value)}
                min={academicYear ? `${academicYear}-01-01` : ''}
                max={academicYear ? `${academicYear}-12-31` : ''}
                disabled={!academicYear}
              />
            </div>
            <div className="form-group col-md-6 mb-3">
              <label>Trimester One End</label>
              <input
                className="form-control homeforms"
                type="date"
                value={trimesterOneEnd}
                onChange={e => setTrimesterOneEnd(e.target.value)}
                min={academicYear ? `${academicYear}-01-01` : ''}
                max={academicYear ? `${academicYear}-12-31` : ''}
                disabled={!academicYear}
              />
            </div>
          </div>
          <div className="form-row mb-3">
            <div className="form-group col-md-6 mb-3">
              <label>Trimester Two Start</label>
              <input
                className="form-control homeforms"
                type="date"
                value={trimesterTwoStart}
                onChange={e => setTrimesterTwoStart(e.target.value)}
                min={academicYear ? `${academicYear}-01-01` : ''}
                max={academicYear ? `${academicYear}-12-31` : ''}
                disabled={!academicYear}
              />
            </div>
            <div className="form-group col-md-6 mb-3">
              <label>Trimester Two End</label>
              <input
                className="form-control homeforms"
                type="date"
                value={trimesterTwoEnd}
                onChange={e => setTrimesterTwoEnd(e.target.value)}
                min={academicYear ? `${academicYear}-01-01` : ''}
                max={academicYear ? `${academicYear}-12-31` : ''}
                disabled={!academicYear}
              />
            </div>
          </div>
          <div className="form-row mb-3">
            <div className="form-group col-md-6 mb-3">
              <label>Trimester Three Start</label>
              <input
                className="form-control homeforms"
                type="date"
                value={trimesterThreeStart}
                onChange={e => setTrimesterThreeStart(e.target.value)}
                min={academicYear ? `${academicYear}-01-01` : ''}
                max={academicYear ? `${academicYear}-12-31` : ''}
                disabled={!academicYear}
              />
            </div>
            <div className="form-group col-md-6 mb-3">
              <label>Trimester Three End</label>
              <input
                className="form-control homeforms"
                type="date"
                value={trimesterThreeEnd}
                onChange={e => setTrimesterThreeEnd(e.target.value)}
                min={academicYear ? `${academicYear}-01-01` : ''}
                max={academicYear ? `${academicYear}-12-31` : ''}
                disabled={!academicYear}
              />
            </div>
          </div>
        </div>

        {/* Annual Section */}
        <div className="mb-4">
          <h5>Annual Period</h5>
          <div className="form-row mb-3">
            <div className="form-group col-md-6 mb-3">
              <label>Annual Start</label>
              <input
                className="form-control homeforms"
                type="date"
                value={annualStart}
                onChange={e => setAnnualStart(e.target.value)}
                min={academicYear ? `${academicYear}-01-01` : ''}
                max={academicYear ? `${academicYear}-12-31` : ''}
                disabled={!academicYear}
              />
            </div>
            <div className="form-group col-md-6 mb-3">
              <label>Annual End</label>
              <input
                className="form-control homeforms"
                type="date"
                value={annualEnd}
                onChange={e => setAnnualEnd(e.target.value)}
                min={academicYear ? `${academicYear}-01-01` : ''}
                max={academicYear ? `${academicYear}-12-31` : ''}
                disabled={!academicYear}
              />
            </div>
          </div>
        </div>

        <div className="form-btn">
          <button className="btn btn-primary btn-block" type="submit">
            Submit Terms
          </button>
        </div>
      </form>
      {result && (
        <div className="alert alert-success mt-3">
          Success: Terms saved successfully
        </div>
      )}
      {error && (
        <div className="alert alert-danger mt-3">
          Error: {error}
        </div>
      )}
    </div>
  );
};

const ManageInstitutionPage = () => {
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12 mb-4">
          <ManageInstitution />
        </div>
        <div className="col-12 mb-4">
          <ManageTerms />
        </div>
      </div>
    </div>
  );
};

export default ManageInstitutionPage;

export { ManageInstitution, Progressions, ManageTerms };

